module.exports = __webpack_public_path__ + "img/14.04c39a21.jpg";